(function heroParallax() {
  const heroes = document.querySelectorAll('[data-hero][data-parallax]');
  if (!heroes.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  heroes.forEach((hero) => {
    const image = hero.querySelector('[data-parallax-image]');
    const content = hero.querySelector('[data-parallax-content]');
    if (!image) return;

    let ticking = false;

    function update() {
      const rect = hero.getBoundingClientRect();
      const scrolledPast = -rect.top;

      const translateY = scrolledPast * 0.4;
      const scale = 1 + Math.min(Math.max(scrolledPast, 0), rect.height) / rect.height * 0.35;
      image.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale})`;

      if (content) {
        const contentProgress = Math.min(Math.max(scrolledPast / rect.height, 0), 1);
        content.style.transform = `translate3d(0, ${contentProgress * 80}px, 0)`;
        content.style.opacity = String(1 - contentProgress * 1.1);
      }

      ticking = false;
    }

    document.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  });
})();
